import PropTypes from 'prop-types'
import React from 'react'

import './Checkbox.less'
import classnames from 'classnames'

const COMPONENT_CLASS = 'nmc-checkbox'

export default class Checkbox extends React.Component {
  constructor (props) {
    super(props)
    this.state = { checked: !!props.checked }
  }

  render () {
    const checked = this.isControlled() ? this.props.checked : this.state.checked
    const classNames = classnames(COMPONENT_CLASS, this.props.className || [])
    return (
      <div className='nmc-checkbox-container'>
        <input type='checkbox' className={classNames} checked={checked} disabled={this.props.disabled} onChange={this.handleChange.bind(this)} />
        <label onClick={this.handleChange.bind(this)} className='checkbox-label'>{this.props.label}</label>
      </div>
    )
  }

  isControlled () {
    return (typeof this.props.checked === 'boolean' && !!this.props.onChange)
  }

  handleChange () {
    if (!this.props.disabled) {
      this.setState({checked: !this.state.checked})
      this.props.onChange && this.props.onChange(this.props.checked || this.state.checked)
    }
  }
}

Checkbox.propTypes = {
  label: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func
}

Checkbox.defaultProps = {
  disabled: false
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/Checkbox/index.js